(() => {
  if (customElements.get('nfiniti-personalization')) return;
  class Personalization extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.text = this.querySelector('[data-ns-text]');
      this.notes = this.querySelector('[data-ns-notes]');
      this.confirm = this.querySelector('[data-ns-confirm]');
      this.count = this.querySelector('[data-ns-count]');
      this.variants = JSON.parse(this.querySelector('[data-ns-variants]').textContent);
      this.storageKey = 'nfiniti-custom-' + this.dataset.product;
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || '{}');
        if (saved.text !== undefined) this.text.value = saved.text;
        if (saved.notes !== undefined) this.notes.value = saved.notes;
      } catch {}
      this.onInput = event => {
        if (event.target === this.confirm) return;
        this.confirm.checked = false;
        this.text.setCustomValidity('');
        this.count.textContent = Array.from(this.text.value).length + ' / ' + this.text.maxLength;
        try { sessionStorage.setItem(this.storageKey, JSON.stringify({text:this.text.value,notes:this.notes.value})); } catch {}
      };
      this.onSubmit = event => {
        const variantId = this.form.querySelector('[name="id"]').value;
        const variant = this.variants.find(item => String(item.id) === variantId);
        const expected = parseInt(variant?.option1, 10);
        const actual = Array.from(this.text.value).length;
        this.text.setCustomValidity('');
        if (this.text.value.trim() && expected && actual !== expected) {
          this.text.setCustomValidity(this.dataset.countMessage.replaceAll('[actual]', actual).replaceAll('[expected]', expected));
        }
        if (!this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
        }
      };
      this.addEventListener('input', this.onInput);
      this.form.addEventListener('submit', this.onSubmit, true);
      this.count.textContent = Array.from(this.text.value).length + ' / ' + this.text.maxLength;
    }
    disconnectedCallback() {
      this.removeEventListener('input', this.onInput);
      this.form?.removeEventListener('submit', this.onSubmit, true);
    }
  }
  customElements.define('nfiniti-personalization', Personalization);
})();
